import React from 'react';
import Form from "react-bootstrap/Form";

const AcademicHistoryInfoForm = ({fields, handleFieldChange, 
                                  graduate, handleSetGraduate, graduateMessage,
                                  messages, page, isEdit, mt}) => {
  return (
    <>
      <h3>最終学歴</h3>
      <dl>
        <dt>最終学歴<span className="red">*</span></dt>
        <dd>
          <Form.Group className="inlineFormControl" controlId="academicHistory" size="lg">
            <Form.Control
              type="text"
              name="academicHistory"
              value={fields.academicHistory}
              onChange={handleFieldChange}
            />
          </Form.Group>
          <Form.Group className="undergraduateBox inlineFormControl" size="lg" style={ (mt == 14 || mt == 15 || mt == 16 || mt == 17) ? {"display": "none" } : {}} >
            <Form.Check
              inline
              label="大学"
              id="graduate"
              name="graduate"
              type="radio"
              value="1"
              checked={ 1 == graduate }
              onChange={ (e) => handleSetGraduate(e) }
            />
            <Form.Check
              inline
              label="大学院"
              name="graduate"
              type="radio"
              value="2"
              checked={ 2 == graduate }
              onChange={ (e) => handleSetGraduate(e) }
            />
            <Form.Check
              inline
              label="その他"
              name="graduate"
              type="radio"
              value="3"
              checked={ 3 == graduate }
              onChange={ (e) => handleSetGraduate(e) }
            />
          </Form.Group>
          <p id="academicHistoryMessage" className="errorMessages">{messages.academicHistory.n}</p>
          <p id="graduateMessage" className="errorMessages">{graduateMessage}</p>
        </dd>

        <dt>卒業年度<span className="red">*</span></dt>
        <dd>
          <Form.Group className="inlineFormControl" controlId="classOfYear" size="lg">
            <Form.Control
              type="text"
              name="classOfYear"
              value={fields.classOfYear}
              onChange={handleFieldChange}
            /> 年卒業
          </Form.Group>
          <p>例： 2020</p>
          <p id="classOfYearMessage" className="errorMessages">{messages.classOfYear.n}</p>
        </dd>

        <dt style={ (mt == 14 || mt == 15 || mt == 16 || mt == 17) ? {} : {"display": "none" }}>卒業予定<span className="red">*</span></dt>
        <dd style={ (mt == 14 || mt == 15 || mt == 16 || mt == 17) ? {} : {"display": "none" }}>
          <Form.Group className="inlineFormControl" controlId="expectedToGraduateOfYear" size="lg">
            <Form.Control
              type="text"
              name="expectedToGraduateOfYear"
              value={fields.expectedToGraduateOfYear}
              onChange={handleFieldChange}
            /> 年3月末
          </Form.Group>
          <p>例： 2020</p>
          <p id="expectedToGraduateOfYearMessage" className="errorMessages">{messages.expectedToGraduateOfYear.n}</p>
        </dd>
      </dl>
    </>

  );
}

export default AcademicHistoryInfoForm;
